// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3bP5i","insightsList":"newBusinessInsightsMenu_insightsList__1R8vI","active":"newBusinessInsightsMenu_active__1juv1"};